import React from 'react'
import NavigationBar from './NavigationBar'
import UserInterface from './UserInterface'
import Navbar from '../General/Navbar'




function Details() {
  return (
    <>
    <NavigationBar />    
    <UserInterface/>
    <Navbar/>          
    </>
  )
}

export default Details